import { render, staticRenderFns } from "./ClubLeague.vue?vue&type=template&id=52559dbb&scoped=true"
import script from "./ClubLeague.vue?vue&type=script&lang=js"
export * from "./ClubLeague.vue?vue&type=script&lang=js"
import style0 from "./ClubLeague.vue?vue&type=style&index=0&id=52559dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52559dbb",
  null
  
)

export default component.exports